import { readStorage, writeStorage } from '@/tools/tools';
/**
 * getters
 */
// export const getters: GetterTree<OrderState, RootState> = {
//   addresslist: (state: OrderState) => state.addresslist,
// };
/**
 * mutations
 */
export var mutations = {
  // 确认订单列表
  CONFIRMORDER: function CONFIRMORDER(state, payload) {
    state.confirmlist = payload;
    writeStorage('confirmlist', state.confirmlist);
  }
};
/**
 * actions
 */
// export const actions: ActionTree<OrderState, RootState> = {
//   confirmOrder({ commit }, payload: []) {
//     commit('CONFIRMORDER', payload);
//   },
// };
/**
 * state
 */
export var state = {
  confirmlist: readStorage('confirmlist') ? readStorage('confirmlist') : []
};
var namespaced = true;
export var order = {
  namespaced: namespaced,
  state: state,
  mutations: mutations
};